<template>
  <div class="accordion">
    <accordion-item v-for="(item, index) in items" :item="item" :key="index">
        <template v-slot:header><div class="" v-html="item.header"></div></template>
        <template v-slot:content><div class="" v-html="item.content"></div></template>
    </accordion-item>
  </div>
</template>

<script>
export default {
  name: 'Accordion',

  props: {
    items: {
      type: Array,
      required: false,
    },
  },
}
</script>

<style scoped>

</style>